<template>
  <div class="class_head">
    <div class="content_left">
      <div class="content_cos">
        <div class="whl-user">
          <div>
            <img
              :src="user_photo"
              @click="goInfo"
              class="cursor"
              alt
              ondragstart="return false;"
            />
            <img :src="userHeadwear" alt="" v-if="userHeadwear" />
          </div>
          <div @click="goInfo" class="cursor">
            <p>{{ realname | realSubstring }}</p>
            <p v-if="internal_users">
              <i></i>
              <span>内部员工</span>
            </p>
          </div>
        </div>
        <!-- <div class="coinbox cursor" @click="openCoinWebView"> -->
        <div class="coinbox cursor">
          <div class="coin">
            <p class="plusNum" v-if="result > 0">+{{ result }}</p>
            <div class="lottie_class_coin">
              <!-- <img
                src="../../../assets/img/common/coin.png"
                style="width: 45px; height: auto; margin-top:44px;"
                alt
                ondragstart="return false;"
              /> -->
            </div>
            <span class="coinAllnum">{{ coinAllnum }}</span>
          </div>
        </div>
        <!-- <div class="badge cursor" @click="goMyBadge">
          <i ref="badge"></i>
          <span>{{userBadgeNum}}</span>
        </div> -->
      </div>
    </div>
    <div
      class="content_right cursor"
      :class="{ content_right_electron: LIMI_ENV }"
    >
      <!--      <div-->
      <!--        v-show="entrance_status"-->
      <!--        :class="['game', updateMark ? 'updateMark' : '']"-->
      <!--        @click="goGameMenu"-->
      <!--      >-->
      <!--        <img src="../../../assets/img/class/gameIcon.png" alt="小游戏入口" />-->
      <!--      </div>-->
      <!--      <div-->
      <!--        v-show="entrance_status"-->
      <!--        :class="['game', is_unread == 1 ? 'updateMark' : '']"-->
      <!--        @click="goMessageList"-->
      <!--      >-->
      <!--        <img-->
      <!--          src="../../../assets/img/class/messageIcon.png"-->
      <!--          alt="消息列表入口"-->
      <!--        />-->
      <!--      </div>-->
      <div class="m-tel" v-if="tel">
        <pre>{{ tel }}</pre>
      </div>
      <div class="cursor filter" @click="toolShow">课程筛选</div>
    </div>
    <!--<router-link to='beforeClass' class="review">
			往期
    </router-link>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import common from "common";
import lottie from "lottie-web-limi";
export default {
  name: "class_head",
  data() {
    return {
      LIMI_ENV: LIMI_ENV === "electron",
      animationSpeed: 1,
      anim: "",
      result: 0,
    };
  },
  computed: {
    ...mapState([
      "userID",
      "realname",
      "userBadgeNum",
      "user_photo",
      "entrance_status",
      "is_unread",
      "internal_users",
      "userHeadwear",
    ]),
    coinAllnum() {
      const coinAllnum = this.$store.state.coinAllnum;
      const lastCoinAllnum = common.get("lastCoinAllnum") || coinAllnum;
      common.set("lastCoinAllnum", coinAllnum);
      const result = coinAllnum - lastCoinAllnum;
      if (result > 0) {
        setTimeout(() => {
          this.result = result;
          this.anim && this.anim.play();
        }, 500);
      }
      return coinAllnum;
    },
  },
  props: {
    updateMark: {
      default: false,
      type: Boolean,
    },
    tel: {
      default: "",
      type: String,
    },
  },
  mounted() {
    this.playAmn();
  },
  methods: {
    goInfo() {
      this.$router.push("/userInfo");
    },
    toolShow() {
      this.$emit("toolShow", true);
    },
    //点击跳转到个人徽章页面
    openCoinWebView() {
      //this.$root.eventHub.$emit("goCoinWebView",true);
      this.$router.push({ name: "coinrecord" });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventCoinClick",
        data: { page: 1 },
      });
    },
    //点击跳转到个人徽章页面
    goMyBadge() {
      this.$router.push({ name: "myselfBadge" });
    },
    goGameMenu() {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventGameClicked",
      });
      this.$router.push({ name: "gameMenu" });
    },
    goMessageList() {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventMessageBtnClick",
        data: {},
      });

      this.$router.push("/msg");
    },
    playAmn() {
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".lottie_class_coin"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: false,
        autoplay: false,
        path: "/static/lottie/coin1.json",
      });
    },
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.class_head {
  width: 100%;
  height: 140px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 24px;
  justify-content: space-between;
  color: #ffffff;
  position: relative;
  z-index: 100;
  //padding: 26px 10px 0 30px;
  padding: 10px 10px 0 38px;
  overflow: hidden;
  box-sizing: border-box;
  .content_left {
    .content_cos {
      height: 61px;
      background: #607da9;
      border-radius: 60px;
      display: flex;
      align-items: center;
    }
    .whl-user {
      width: auto;
      height: 140px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #fff;
      margin-left: -37px;
      & > div:first-child {
        width: 140px;
        height: 140px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        & > img:first-child {
          width: 81px;
          height: 81px;
          border-radius: 50%;
          border: 2px solid #fff;
          position: relative;
          z-index: 2;
        }
        & > img:nth-child(2) {
          width: 140px;
          height: 140px;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 3;
          pointer-events: none;
        }
      }
      & > div:nth-child(2) {
        min-width: 136px;
        height: 61px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        border-radius: 0 28px 28px 0;
        margin-left: -12px;
        padding-right: 20px;
        & > p:first-child {
          color: #fff;
          font-size: 24px;
        }
        & > p:nth-child(2) {
          width: 100%;
          height: 20px;
          font-size: 14px;
          color: #ffe286;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          & > i {
            display: block;
            width: 20px;
            height: 20px;
            background: url("../../../assets/img/class/own.png") no-repeat left
              center;
            background-size: 11px;
          }
        }
      }
    }
    .coinbox {
      position: relative;
      .coin {
        pointer-events: none;
        position: relative;
        left: -25px;
        top: -1px;
        .lottie_class_coin {
          position: absolute;
          top: -48px;
          width: 110px;
          height: 103px;
        }
        .coinani {
          display: inline-block;
          vertical-align: middle;
          position: relative;
          top: -14px;
          z-index: 2;
          pointer-events: none;
        }
        .plusNum {
          position: absolute;
          opacity: 0;
          top: -10px;
          left: 100px;
          z-index: 2;
          font-size: 16px;
          animation: plusani 0.6s ease-in;
          -webkit-animation: plusani 0.6s ease-in;
        }
      }
    }

    .coin,
    .badge {
      i {
        padding: 10px 25px;
        background: url(../../../assets/img/common/coin.png) no-repeat left
          center;
        background-size: 50px 50px;
        position: relative;
        z-index: 2;
      }
      span {
        padding: 0 22px 0 35px;
        position: relative;
        z-index: 1;
        margin-left: -25px;
        top: 3px;
        border-radius: 0 22px 22px 0;
        font-family: Roboto_Regular;
      }
      .coinAllnum {
        margin-left: 55px;
        z-index: 1;
      }
    }
    .badge {
      margin-left: -20px;
      i {
        background: url(../../../assets/img/common/badge.png) no-repeat left
          center;
        background-size: 46px 46px;
      }
      span {
        padding: 6px 22px 6px 35px;
      }
    }
    .review {
      width: 78px;
      height: 59px;
      background: url(../../../assets/img/class/review_bg.png) no-repeat center
        center;
      background-size: 100% 100%;
      position: absolute;
      right: 20px;
      top: 44px;
      font-size: 20px;
      line-height: 80px;
      color: #ffffff;
    }
  }
  .content_right_electron {
    margin-right: 80px;
  }
  .content_right {
    width: 300px;
    text-align: right;
    display: flex;
    .game {
      position: relative;
      height: 50px;
      display: inline-block;
      margin-right: 20px;
      width: 50px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .m-tel {
      flex: 1;
      text-align: left;
      display: flex;
      align-items: center;
    }
    .m-tel pre {
      font-size: 14px;
      font-family: "PingFang_Regular";
    }
    .filter {
      display: inline-block;
      width: 93px;
      height: 50px;
      background: #607da9;
      font-size: 16px;
      line-height: 50px;
      border-radius: 28px;
      text-align: center;
    }
    .updateMark::after {
      position: absolute;
      display: block;
      content: "";
      width: 10px;
      height: 10px;
      background: #f56c22;
      right: 1px;
      top: 1px;
      border-radius: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/class/class_head.vue